import React from 'react'
import { Container, Modal, Spacer, Text } from 'roadie-ui'
import { useSelector } from 'react-redux'
import { LocalizedText, useLocalization } from 'localization'

const SenderRecognitionsInfoModal: React.FC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => {
  const { t } = useLocalization()
  const isWebView = useSelector<any, boolean>((state) => state.config.isWebview)

  return (
    <Modal.Basic
      open={open}
      onRequestClose={onClose}
      width={isWebView ? '350px' : '500px'}
      closeButtonText={t('dweb_common_close')}
    >
      <Container.Base $textAlign="center">
        <Text.H3 $fontWeight="bold" $color="neutral-black">
          <LocalizedText translationKey="dweb_dashboard_sender_recognitions_info_modal_sender_recognitions" />
        </Text.H3>
        <Spacer $height="1.6rem" />
        <Text.Body1 $color="neutral-darker">
          <LocalizedText translationKey="dweb_dashboard_sender_recognitions_info_modal_description" />
        </Text.Body1>
        <Spacer $height="1.6rem" />
        <Text.Body1 $color="neutral-darker">
          <LocalizedText translationKey="dweb_dashboard_sender_recognitions_info_modal_reputation_description" />
        </Text.Body1>
        <Spacer $height="2.4rem" />
      </Container.Base>
    </Modal.Basic>
  )
}

export default SenderRecognitionsInfoModal
